import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

const SignOutButton = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Cerrar modal con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      // Llama a tu backend para cerrar sesión (ajusta el endpoint si cambia)
      await fetch(`${API_BASE}/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("Error al cerrar sesión:", err);
      // Si quieres, aquí podrías mostrar un toast
    } finally {
      setLoading(false);
      setOpen(false);
      navigate("/login", { replace: true });
    }
  };

  return (
    <>
      {/* Botón fijo, siempre rojo */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="bg-red-600 text-white font-semibold px-4 py-2 rounded-lg w-full mt-6 hover:bg-red-700 transition"
      >
        Cerrar sesión
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-[90]">
          {/* Backdrop */}
          <button
            className="absolute inset-0 bg-slate-900/60"
            aria-label="Cerrar modal"
            onClick={() => setOpen(false)}
          />
          {/* Contenedor */}
          <div className="relative mx-auto max-w-md w-[92%] sm:w-[85%] mt-24">
            <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-xl">
              <div className="flex items-start justify-between gap-3">
                <h3 className="text-lg font-extrabold text-slate-800">
                  ¿Cerrar sesión?
                </h3>
                <button
                  type="button"
                  className="p-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50"
                  onClick={() => setOpen(false)}
                  aria-label="Cerrar"
                >
                  ✕
                </button>
              </div>

              <p className="mt-3 text-slate-600">
                Se cerrará tu sesión actual y volverás a la pantalla de inicio de sesión del panel.
              </p>

              <div className="mt-6 grid grid-cols-2 gap-3">
                <button
                  type="button"
                  className="rounded-xl border border-slate-200 px-4 py-2 hover:bg-slate-50"
                  onClick={() => setOpen(false)}
                  disabled={loading}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleConfirm}
                  disabled={loading}
                  className="rounded-xl px-4 py-2 text-white bg-red-600 hover:bg-red-700 disabled:opacity-60"
                >
                  {loading ? "Saliendo..." : "Cerrar sesión"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignOutButton;
